import {
    EDIT_ASSIGN_CANDIDATE_REQUEST,
    EDIT_ASSIGN_CANDIDATE_SUCCESS,
    EDIT_ASSIGN_CANDIDATE_FAILURE,

} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editAssignCandidateByHrRducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ASSIGN_CANDIDATE_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_ASSIGN_CANDIDATE_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_ASSIGN_CANDIDATE_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editAssignCandidateByHrRducer;